import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/wbst-spotlight-blank-lg.webp")